import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import posed from 'react-pose';

import styles from './styles.module.css';

const Button = ({
    type, href, theme, children, hostRef, className, ...rest
}) => (
    href
        ? (
            <a
                href={href}
                ref={hostRef}
                className={classnames(styles.button, styles[theme], className)}
                {...rest}
            >
                <span>{children}</span>
            </a>
        )
        : (
            <button
                ref={hostRef}
                type={type}
                className={classnames(styles.button, styles[theme], className)}
                {...rest}
            >
                <span>{children}</span>
            </button>
        )
);

Button.propTypes = {
    type: PropTypes.oneOf(['button', 'submit']),
    href: PropTypes.string,
    theme: PropTypes.oneOf(['primary', 'secondary', 'outline']),
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    hostRef: PropTypes.func.isRequired,
};

Button.defaultProps = {
    type: null,
    href: null,
    theme: 'primary',
    className: null,
};

export default posed(Button)();
